import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = { class: "relative h-full flex" };
const _hoisted_2 = { class: "bg-gray-50 px-6 py-4 border-b border-gray-200" };
const _hoisted_3 = { class: "flex items-center justify-between" };
const _hoisted_4 = { class: "text-xl font-bold text-gray-900 flex items-center" };
const _hoisted_5 = { class: "flex-1 overflow-hidden flex flex-col" };
const _hoisted_6 = {
    key: 0,
    class: "flex-1 flex flex-col items-center justify-center p-8 text-center"
};
const _hoisted_7 = { class: "text-xl font-semibold text-gray-900 mb-2" };
const _hoisted_8 = { class: "text-gray-600 mb-6" };
const _hoisted_9 = {
    key: 0,
    class: "flex-1 overflow-y-auto"
};
const _hoisted_10 = { class: "p-4 space-y-4" };
const _hoisted_11 = { class: "flex gap-4" };
const _hoisted_12 = { class: "flex-shrink-0" };
const _hoisted_13 = ["src", "alt"];
const _hoisted_14 = { class: "flex-1 min-w-0" };
const _hoisted_15 = { class: "font-semibold text-gray-900 truncate pr-2" };
const _hoisted_16 = { class: "text-sm text-gray-600 mb-2 line-clamp-2" };
const _hoisted_17 = { class: "flex items-center gap-3 mt-2" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = { class: "font-semibold text-gray-900 min-w-[2rem] text-center" };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
    key: 0,
    class: "border-t border-gray-200 p-6 bg-white"
};
const _hoisted_22 = { class: "flex justify-between items-center mb-4" };
const _hoisted_23 = { class: "text-lg font-semibold text-gray-700" };
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useCartStore } from '@shared/composables/useCartStore';
import { MoneyUtils } from '@shared/utils/MoneyUtils';
import CartMenuLine from '@shared/components/menu/CartMenuLine.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartComponentBase',
    props: {
        theme: { default: () => ({ primary: 'red', secondary: 'gray' }) },
        translations: { default: () => ({
                title: 'Warenkorb',
                emptyTitle: 'Ihr Warenkorb ist leer',
                emptyMessage: 'Fügen Sie köstliche Gerichte aus unserer Speisekarte hinzu!',
                toMenuButton: 'Zur Speisekarte',
                total: 'Gesamt',
                checkoutButton: 'Zur Kasse'
            }) },
        menuRoute: { default: '/speisekarte' },
        checkoutRoute: { default: '/checkout' },
        defaultImage: { default: '/assets/default-food-image.svg' }
    },
    setup(__props) {
        const props = __props;
        // Store & Router
        const cartStore = useCartStore();
        const router = useRouter();
        // Computed
        const totalAmount = computed(() => cartStore.totalPrice);
        const totalAmountCent = computed(() => {
            return cartStore.items.reduce((sum, item) => {
                return sum + (item.totalPriceCent || (item.totalPrice * 100));
            }, 0);
        });
        // Methods
        const handleOverlayClick = (event) => {
            if (event.target === event.currentTarget) {
                cartStore.closeCart();
            }
        };
        const handleImageError = (event) => {
            const target = event.target;
            target.src = props.defaultImage;
        };
        const navigateToMenu = () => {
            cartStore.closeCart();
            router.push(props.menuRoute);
        };
        const increaseQuantity = (item) => {
            cartStore.updateQuantity(item.configId || item.id, item.quantity + 1);
        };
        const decreaseQuantity = (item) => {
            if (item.quantity > 1) {
                cartStore.updateQuantity(item.configId || item.id, item.quantity - 1);
            }
            else {
                cartStore.removeItem(item.configId || item.id);
            }
        };
        const proceedToCheckout = () => {
            cartStore.closeCart();
            router.push(props.checkoutRoute);
        };
        const formatPrice = (price, priceCent) => {
            if (priceCent !== undefined) {
                return MoneyUtils.formatCurrency(priceCent);
            }
            return MoneyUtils.formatCurrency(Math.round(price * 100));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createCommentVNode(" Cart Overlay/Modal "),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    (_unref(cartStore).isOpen)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "fixed inset-0 z-50 overflow-hidden",
                            onClick: handleOverlayClick
                        }, [
                            _createCommentVNode(" Backdrop "),
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300" }, null, -1 /* CACHED */)),
                            _createCommentVNode(" Cart Panel "),
                            _createElementVNode("div", _hoisted_1, [
                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hidden lg:flex lg:flex-1" }, null, -1 /* CACHED */)),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["relative bg-white w-full lg:w-96 xl:w-[28rem] h-full flex flex-col shadow-2xl transform transition-transform duration-300", _unref(cartStore).isOpen ? 'translate-x-0' : 'translate-x-full'])
                                }, [
                                    _createCommentVNode(" Cart Header "),
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("h2", _hoisted_4, [
                                                _createElementVNode("i", {
                                                    class: _normalizeClass(["fas fa-shopping-cart mr-3", `text-${_ctx.theme.primary}-600`])
                                                }, null, 2 /* CLASS */),
                                                _createTextVNode(" " + _toDisplayString(_ctx.translations.title) + " ", 1 /* TEXT */),
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["ml-2 px-2 py-1 rounded-full text-sm", `bg-${_ctx.theme.primary}-100 text-${_ctx.theme.primary}-800`])
                                                }, _toDisplayString(_unref(cartStore).itemCount), 3 /* TEXT, CLASS */)
                                            ]),
                                            _createElementVNode("button", {
                                                onClick: _cache[0] || (_cache[0] =
                                                    //@ts-ignore
                                                    (...args) => (_unref(cartStore).closeCart && _unref(cartStore).closeCart(...args))),
                                                class: "p-2 hover:bg-gray-200 rounded-full transition-colors duration-200"
                                            }, [...(_cache[1] || (_cache[1] = [
                                                    _createElementVNode("i", { class: "fas fa-times text-gray-600 text-xl" }, null, -1 /* CACHED */)
                                                ]))])
                                        ])
                                    ]),
                                    _createCommentVNode(" Cart Content "),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createCommentVNode(" Empty Cart State "),
                                        (_unref(cartStore).isEmpty)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6" }, [
                                                    _createElementVNode("i", { class: "fas fa-shopping-cart text-4xl text-gray-400" })
                                                ], -1 /* CACHED */)),
                                                _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.translations.emptyTitle), 1 /* TEXT */),
                                                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.translations.emptyMessage), 1 /* TEXT */),
                                                _createElementVNode("button", {
                                                    onClick: navigateToMenu,
                                                    class: _normalizeClass(["px-6 py-3 rounded-lg font-semibold transition-colors duration-200 text-white", `bg-${_ctx.theme.primary}-600 hover:bg-${_ctx.theme.primary}-700`])
                                                }, _toDisplayString(_ctx.translations.toMenuButton), 3 /* TEXT, CLASS */)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createCommentVNode(" Cart Items - Slot for custom rendering "),
                                        _renderSlot(_ctx.$slots, "cart-items", {
                                            items: _unref(cartStore).items
                                        }, () => [
                                            _createCommentVNode(" Default cart items rendering "),
                                            (!_unref(cartStore).isEmpty)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _createElementVNode("div", _hoisted_10, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartStore).items, (item) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: item.configId || item.id,
                                                                class: "bg-white border border-gray-200 rounded-xl p-4 shadow-sm"
                                                            }, [
                                                                _renderSlot(_ctx.$slots, "cart-item", {
                                                                    item: item,
                                                                    increase: increaseQuantity,
                                                                    decrease: decreaseQuantity
                                                                }, () => [
                                                                    (item.itemType === 'menu')
                                                                        ? (_openBlock(), _createBlock(CartMenuLine, {
                                                                            key: 0,
                                                                            item: item,
                                                                            class: "w-full"
                                                                        }, null, 8 /* PROPS */, ["item"]))
                                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                            _createCommentVNode(" Default item rendering "),
                                                                            _createElementVNode("div", _hoisted_11, [
                                                                                _createElementVNode("div", _hoisted_12, [
                                                                                    _createElementVNode("img", {
                                                                                        src: item.menuItem.imageUrl,
                                                                                        alt: item.menuItem.name,
                                                                                        class: "w-16 h-16 object-cover rounded-lg",
                                                                                        onError: handleImageError
                                                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13)
                                                                                ]),
                                                                                _createElementVNode("div", _hoisted_14, [
                                                                                    _createElementVNode("h4", _hoisted_15, _toDisplayString(item.menuItem.name), 1 /* TEXT */),
                                                                                    _createElementVNode("p", _hoisted_16, _toDisplayString(item.selectedSize?.name || item.menuItem.description), 1 /* TEXT */),
                                                                                    _createCommentVNode(" Quantity Controls "),
                                                                                    _createElementVNode("div", _hoisted_17, [
                                                                                        _createElementVNode("button", {
                                                                                            onClick: ($event) => (decreaseQuantity(item)),
                                                                                            class: "w-9 h-9 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full flex items-center justify-center transition-colors duration-200"
                                                                                        }, [...(_cache[3] || (_cache[3] = [
                                                                                                _createElementVNode("i", { class: "fas fa-minus text-xs" }, null, -1 /* CACHED */)
                                                                                            ]))], 8 /* PROPS */, _hoisted_18),
                                                                                        _createElementVNode("span", _hoisted_19, _toDisplayString(item.quantity), 1 /* TEXT */),
                                                                                        _createElementVNode("button", {
                                                                                            onClick: ($event) => (increaseQuantity(item)),
                                                                                            class: _normalizeClass(["w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-200 font-semibold shadow-sm text-white", `bg-${_ctx.theme.primary}-600 hover:bg-${_ctx.theme.primary}-700`])
                                                                                        }, [...(_cache[4] || (_cache[4] = [
                                                                                                _createElementVNode("i", { class: "fas fa-plus text-xs" }, null, -1 /* CACHED */)
                                                                                            ]))], 10 /* CLASS, PROPS */, _hoisted_20)
                                                                                    ])
                                                                                ])
                                                                            ])
                                                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                                ])
                                                            ]));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createCommentVNode(" Cart Footer - Slot for checkout button "),
                                        _renderSlot(_ctx.$slots, "cart-footer", {
                                            total: totalAmount.value,
                                            checkout: proceedToCheckout
                                        }, () => [
                                            (!_unref(cartStore).isEmpty)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                    _createElementVNode("div", _hoisted_22, [
                                                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.translations.total), 1 /* TEXT */),
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["font-bold text-lg", `text-${_ctx.theme.primary}-600`])
                                                        }, _toDisplayString(formatPrice(totalAmount.value, totalAmountCent.value)), 3 /* TEXT, CLASS */)
                                                    ]),
                                                    _createElementVNode("button", {
                                                        onClick: proceedToCheckout,
                                                        class: _normalizeClass(["w-full py-4 rounded-lg font-semibold text-white transition-all duration-200 transform hover:scale-[1.02] shadow-lg text-lg", `bg-${_ctx.theme.primary}-600 hover:bg-${_ctx.theme.primary}-700 hover:shadow-xl`])
                                                    }, _toDisplayString(_ctx.translations.checkoutButton), 3 /* TEXT, CLASS */)
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ], 2 /* CLASS */)
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]))
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
        };
    }
});
